<script setup lang="ts">
import {
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
  TooltipPortal,
  TooltipContent,
} from 'radix-vue'

withDefaults(
  defineProps<{
    content?: string
    side?: 'top' | 'bottom' | 'left' | 'right'
  }>(),
  { side: 'top', content: '' },
)
</script>

<template>
  <TooltipProvider :delay-duration="300">
    <TooltipRoot>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          :side="side"
          :side-offset="6"
          class="z-50 max-w-[220px] px-3 py-2 rounded bg-on-surface text-surface font-mono text-[0.65rem] shadow-lg"
        >
          <slot name="content">{{ content }}</slot>
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>
